import React from 'react';
import { Users } from 'lucide-react';
import ModulePageLayout, { Section } from '../../components/ModulePageLayout';
import { getModule } from '../../data/modules';

const SECTORS = [
  'Liquidity', 'Asset Backed', 'Rewards Backed', 'Crypto Liquidity', 'Small Business Fund',
  'Real Estate', 'Revenue Backed', 'P2P', 'P2B (Peer to Business)', 'Hospitality',
];

export default function CapitalPoolsPage() {
  const module = getModule('capital-pools')!;
  return (
    <ModulePageLayout module={module} Icon={Users}>
      <Section title="Collective Investing, By Sector">
        <p className="text-gray-700 leading-relaxed">
          Capital Pools aggregate funds from multiple participants into sector-specific investment vehicles —
          from Tipsville-style tip-sharing pools to traditional Rosca rotating savings groups. Each pool
          carries a risk level, a numeric risk score, and a social impact score, so you can evaluate it
          holistically before committing.
        </p>
      </Section>

      <Section title="Sectors You Can Invest In">
        <div className="flex flex-wrap gap-2">
          {SECTORS.map((s) => (
            <span key={s} className="px-3 py-1.5 bg-teal-50 text-teal-800 rounded-full text-sm font-medium border border-teal-200">
              {s}
            </span>
          ))}
        </div>
      </Section>

      <Section title="On-Chain or Off-Chain — Your Choice">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          <div className="border border-gray-200 rounded-xl p-5">
            <h3 className="font-bold text-gray-900 mb-2">On-Chain Pools</h3>
            <p className="text-gray-600 text-sm">Tokenized on blockchain with smart contracts — transparent, auditable, programmable distributions.</p>
          </div>
          <div className="border border-gray-200 rounded-xl p-5">
            <h3 className="font-bold text-gray-900 mb-2">Off-Chain Pools</h3>
            <p className="text-gray-600 text-sm">Traditional bank account structure with custodial management and tracked collateral.</p>
          </div>
        </div>
        <p className="text-gray-700 leading-relaxed mt-5">
          Every pool defines minimum and maximum contribution amounts, supports recurring contributions, and
          may lock funds for a defined period. Before committing capital, you can simulate projected returns
          based on the pool's ROI and your contribution amount. Businesses and individuals can also submit
          funding requests, evaluated on requested amount, purpose, and repayment terms.
        </p>
      </Section>
    </ModulePageLayout>
  );
}
